import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import App from './App';
import './index.css';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

const theme = getMuiTheme({

});

const FinalApp = () => (
    <MuiThemeProvider muiTheme={theme}>
      <App />
    </MuiThemeProvider>
);

ReactDOM.render(
  <FinalApp />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js